import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import React from 'react';
import Schema from 'async-validator';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import merge from 'lodash/merge';
import set from 'lodash/set'; // import useForceUpdate from './useForceUpdate'

import devwarning from '../../_utils/devwarning';
export var INTERNAL_HOOK_KEY = '__KD_INTERNAL_FORM_HOOK__';

var FormStore = /*#__PURE__*/_createClass(function FormStore() {
  var _this = this;

  _classCallCheck(this, FormStore);

  this.isMounted = false; // private forceRootUpdate:() => void

  this.defaultValues = {};
  this.store = {};
  this.fields = {};
  this.rules = {};
  this.errorMessages = {};
  this.callbacks = {}; // constructor (forceRootUpdate: () => void) {
  //   this.forceRootUpdate = forceRootUpdate
  // }

  this.getForm = function () {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getDefaultValue: _this.getDefaultValue,
      getFieldError: _this.getFieldError,
      getFieldsError: _this.getFieldsError,
      resetFields: _this.resetFields,
      setFieldValue: _this.setFieldValue,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      getInternalHooks: _this.getInternalHooks
    };
  };

  this.getInternalHooks = function (key) {
    if (key !== INTERNAL_HOOK_KEY) {
      devwarning(false, 'Form', '`getInternalHooks` is internal usage.');
      return null;
    }

    _this.isMounted = true;
    return {
      dispatch: _this.dispatch,
      setDefaultValues: _this.setDefaultValues,
      setCallbacks: _this.setCallbacks,
      registerField: _this.registerField
    };
  };

  this.warningUnhooked = function () {
    !_this.isMounted && devwarning(false, 'Form', 'Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?');
  };
  /**
   * Dispath. 用于 Field 触发数据变更
   * @param action
   */


  this.dispatch = function (action) {
    _this.warningUnhooked();

    var namePath = action.namePath;

    switch (action.type) {
      case 'updateValue':
        _this.updateValue(namePath, action.value);

        break;

      case 'validateField':
        _this.validateFields([namePath]);

        break;

      default:
        break;
    }
  };

  this.setDefaultValues = function (values) {
    _this.warningUnhooked();

    if (!values) return;
    var copyDefaultValues = cloneDeep(_this.defaultValues);
    var copyValues = cloneDeep(values);
    _this.defaultValues = _extends(_extends({}, copyDefaultValues), copyValues);
    _this.store = merge(_this.store, values);
  };

  this.getDefaultValue = function (name) {
    _this.warningUnhooked();

    return get(_this.defaultValues, name);
  };

  this.getFieldValue = function (name) {
    _this.warningUnhooked();

    return get(_this.store, name);
  };

  this.setFieldValue = function (name, value) {
    _this.warningUnhooked();

    _this.setFieldsValue(_defineProperty({}, name, value));
  };

  this.getFieldsValue = function (namePathList) {
    _this.warningUnhooked();

    if (!namePathList) {
      return cloneDeep(_this.store);
    }

    var fieldsValue = {};
    namePathList.forEach(function (name) {
      fieldsValue[name] = get(_this.store, name);
    });
    return fieldsValue;
  };

  this.setFieldsValue = function (store) {
    _this.warningUnhooked();

    if (!store) return;
    var prevStore = cloneDeep(_this.store);
    _this.store = merge(_this.store, store);

    _this.notifyObservers(prevStore, null, 'externalUpdateValue');
  };

  this.getFieldError = function (name) {
    _this.warningUnhooked();

    return get(_this.errorMessages, name);
  };

  this.getFieldsError = function (namePathList) {
    _this.warningUnhooked();

    if (!namePathList) {
      return cloneDeep(_this.errorMessages);
    }

    var result = {};
    namePathList.forEach(function (name) {
      result[name] = _this.errorMessages[name];
    });
    return result;
  };

  this.getRules = function (namePathList) {
    _this.warningUnhooked();

    if (!namePathList) {
      return _this.rules;
    }

    var rules = {};
    namePathList.forEach(function (name) {
      if (_this.rules[name]) {
        rules[name] = cloneDeep(_this.rules[name]);
      }
    });
    return _Object$keys(rules).length === 0 ? null : rules;
  };

  this.setRules = function (name, rules) {
    _this.warningUnhooked();

    set(_this.rules, name, rules);
  };

  this.setCallbacks = function (callbacks) {
    _this.warningUnhooked();

    _this.callbacks = cloneDeep(callbacks);
  };

  this.resetFields = function () {
    _this.warningUnhooked();

    var prevStore = cloneDeep(_this.store); // 重置时，无默认值的 field value 不能设置为 undefined
    // 部分控件 undefined 的话不会生效

    var newStore = {};

    for (var key in _this.store) {
      newStore[key] = _this.defaultValues[key] ? _this.defaultValues[key] : '';
    }

    _this.store = newStore;
    _this.errorMessages = {};

    _this.notifyObservers(prevStore, null, 'reset');
  };

  this.updateValue = function (name, value) {
    _this.warningUnhooked();

    var prevStore = cloneDeep(_this.store);
    set(_this.store, name, value);
    var trigger = get(_this.fields, [name, 'meta', 'trigger']); // 默认是 onChange 触发校验

    if (trigger === undefined || trigger === 'onChange' || _includesInstanceProperty(trigger).call(trigger, 'onChange')) {
      _this.validateFields([name]);
    } else {
      _this.notifyObservers(prevStore, [name], 'updateValue');
    }

    var onValuesChange = _this.callbacks.onValuesChange;

    if (onValuesChange) {
      onValuesChange(_defineProperty({}, name, value), cloneDeep(_this.store));
    }
  };
  /**
   * 注册 Field
   * Field 如果带有验证规则的话，则注册时进行校验
   * @param name Field 名称
   * @param field Field 实例
   */


  this.registerField = function (name, field) {
    _this.warningUnhooked();

    _this.fields[name] = field;
    var meta = field.meta;

    if (meta.rules !== undefined) {
      _this.setRules(name, meta.rules); // TODO: 初始化的时候是否需要校验？？
      // this.validateFields([name]).catch(({ errorInfos }) => {
      //   this.validateFieldFaild(errorInfos, 'internal')
      // })

    }
  };

  this.validateFields = function (namePathList) {
    _this.warningUnhooked();

    var rules = _this.getRules(namePathList); // 没有设置校验规则的情况下，不做校验


    if (!rules) return _Promise.resolve({
      values: cloneDeep(_this.store)
    });
    var validator = new Schema(rules);
    var validatePromise = new _Promise(function (resolve, reject) {
      validator.validate(_this.store).then(function () {
        resolve({
          values: cloneDeep(_this.store)
        });
      }).catch(function (_ref) {
        var errors = _ref.errors,
            fields = _ref.fields;
        // eslint-disable-next-line
        console.log(errors); // eslint-disable-next-line  prefer-promise-reject-errors

        reject({
          errors: errors,
          errorInfos: {
            values: cloneDeep(_this.store),
            fields: fields
          }
        });
      });
    });
    /**
     * 内部校验用
     */

    validatePromise.then(function () {
      namePathList === null || namePathList === void 0 ? void 0 : namePathList.forEach(function (name) {
        _this.errorMessages[name] && delete _this.errorMessages[name];
      });

      _this.notifyObservers(_this.store, namePathList || [], 'validateFinish');
    }).catch(function (_ref2) {
      var errorInfos = _ref2.errorInfos;
      var _errorInfos$fields = errorInfos.fields,
          fields = _errorInfos$fields === void 0 ? {} : _errorInfos$fields;

      _Object$keys(fields).forEach(function (name) {
        // 取第一个错误的信息
        _this.errorMessages[name] = fields[name][0].message;
      });

      _this.notifyObservers(_this.store, namePathList || [], 'validateFinish');
    }); // 返回 promise 给外部调用者

    return validatePromise;
  };

  this.submit = function () {
    _this.warningUnhooked();

    _this.validateFields().then(function (values) {
      var onFinish = _this.callbacks.onFinish;

      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          console.error(err);
        }
      }
    }).catch(function (_ref3) {
      var errorInfos = _ref3.errorInfos;
      var onFinishFailed = _this.callbacks.onFinishFailed;

      if (onFinishFailed) {
        onFinishFailed(errorInfos);
      }
    });
  };

  this.notifyObservers = function (prevStore, namePathList, source) {
    _this.warningUnhooked();

    _Object$values(_this.fields).forEach(function (_ref4) {
      var onStoreChange = _ref4.onStoreChange;
      var stores = {
        prev: prevStore,
        curr: _this.store
      };
      onStoreChange(stores, namePathList, source);
    });
  };
});

function useForm(form) {
  var formRef = React.useRef(); // const forceUpdate = useForceUpdate()

  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      // Create a new FormStore if not provided
      // const forceReRender = () => {
      //   forceUpdate()
      // }
      var formStore = new FormStore();
      formRef.current = formStore.getForm();
    }
  }

  return [formRef.current];
}

export default useForm;